import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#0f1419] text-white">
      <div className="max-w-4xl mx-auto px-6 py-10">
        <div className="flex items-center justify-between mb-6">
          <Link
            to="/login"
            className="flex items-center gap-2 text-[#84cc34] hover:text-[#089453] transition-colors"
          >
            <FaArrowLeft />
            Voltar
          </Link>
          <span className="text-white/50 text-sm">Última atualização: 02/02/2026</span>
        </div>

        <h1 className="text-3xl font-bold mb-4">Política de Privacidade</h1>
        <p className="text-white/80 leading-relaxed mb-6">
          Esta Política de Privacidade descreve como o Abastece+ coleta, usa, armazena,
          compartilha e protege informações pessoais. Ao utilizar nossos serviços, você
          concorda com as práticas descritas neste documento.
        </p>

        <section className="space-y-4">
          <div>
            <h2 className="text-xl font-semibold text-white mb-2">1. Quem somos</h2>
            <p className="text-white/75 leading-relaxed">
              O Abastece+ é um aplicativo para gestão de abastecimentos, cashback e rotas.
              Em caso de dúvidas, solicitações ou reclamações sobre privacidade, entre em
              contato pelo canal de suporte do aplicativo ou pelo e-mail
              suporte@abastecemaisapp.com.br.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-white mb-2">2. Dados que coletamos</h2>
            <ul className="list-disc list-inside text-white/75 leading-relaxed space-y-1">
              <li>Dados de cadastro: nome, e-mail, telefone, CPF/CNPJ.</li>
              <li>Dados de uso: histórico de abastecimentos, veículos, postos e rotas.</li>
              <li>Dados de localização, quando autorizado, para postos próximos e rotas.</li>
              <li>Dados técnicos: dispositivo, sistema operacional, logs de acesso e performance.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-white mb-2">3. Como usamos seus dados</h2>
            <ul className="list-disc list-inside text-white/75 leading-relaxed space-y-1">
              <li>Fornecer as funcionalidades do serviço e personalizar sua experiência.</li>
              <li>Processar cadastros, convites e validações de cashback.</li>
              <li>Atender solicitações de suporte e melhorar nossos serviços.</li>
              <li>Cumprir obrigações legais, regulatórias e de segurança.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-white mb-2">4. Base legal (LGPD)</h2>
            <p className="text-white/75 leading-relaxed">
              Tratamos dados com base na execução de contrato, cumprimento de obrigação legal,
              exercício regular de direitos e legítimo interesse. Quando necessário, solicitamos
              seu consentimento, que pode ser revogado a qualquer momento.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-white mb-2">5. Compartilhamento de dados</h2>
            <p className="text-white/75 leading-relaxed">
              Podemos compartilhar dados com prestadores de serviço, parceiros operacionais
              e autoridades públicas quando exigido por lei. Não vendemos dados pessoais.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-white mb-2">6. Armazenamento e retenção</h2>
            <p className="text-white/75 leading-relaxed">
              Mantemos seus dados apenas pelo tempo necessário para cumprir as finalidades
              descritas, respeitando prazos legais e regulatórios.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-white mb-2">7. Segurança</h2>
            <p className="text-white/75 leading-relaxed">
              Adotamos medidas técnicas e administrativas para proteger seus dados contra acesso
              não autorizado, perda, uso indevido, alteração e divulgação.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-white mb-2">8. Seus direitos</h2>
            <p className="text-white/75 leading-relaxed">
              Você pode solicitar confirmação de tratamento, acesso, correção, anonimização,
              portabilidade, exclusão e informações sobre compartilhamento. Solicitações podem
              ser feitas pelos canais de suporte.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-white mb-2">9. Crianças e adolescentes</h2>
            <p className="text-white/75 leading-relaxed">
              O aplicativo não é destinado a menores de 18 anos. Caso identifiquemos dados de
              menores, eles poderão ser removidos.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-white mb-2">10. Alterações nesta política</h2>
            <p className="text-white/75 leading-relaxed">
              Podemos atualizar esta política periodicamente. Avisaremos quando houver mudanças
              relevantes e indicaremos a data da última atualização.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-white mb-2">11. Contato</h2>
            <p className="text-white/75 leading-relaxed">
              Dúvidas ou solicitações: suporte@abastecemaisapp.com.br.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
